<div class="">
    <div class="row justify-content-center">

        <div class="">
            <div class="alert alert-info alert-dismissible fade show px-4 mb-0 text-center" role="alert">
                <i class="mdi mdi-alert-circle-outline d-block display-4 mt-2 mb-3 text-info"></i>
                <h5 class="text-info">Estapa Concluída!</h5>
            </div>
        </div>
    </div>
</div>